export enum MsgCode {
  INVALID_NT_REFERENCE = "XTEE-003",      // User has withdrawn consent in NT.
  FALLBACK_TO_PRESCRIPTION = "XTEE-004",  // Likely an X-Road server timeout, falling back to regular database query.
  TECHNICAL_ERROR = "XTEE-005",           // Unknown error from X-Road Retseptikeskus request.
  DUMMY_EXCEPTION = "DUMMY-001",          // This is dummy error/exception. Can be replaced/Deleted if we start handling business exceptions/errors in GlobalErrorAndExceptionHandler
}
